export default "if (a) {\n     b=c;\nfunction foo(d) {\n           e=f;\n }\n}\n\nif (a) {\n  b=c;\n  function foo(d) {\n    e=f;\n  }\n}\n\nfoo\n.bar\n.baz()"